import React, { useMemo } from 'react';
import { useBlockLayout, useExpanded, useTable } from 'react-table-v7';
import { useRowSelect } from './useRowSelect';
import usePermissions from '../../../../../hooks/common/usePermissions';

import permissionTableColumns from './permissionTableColumns';
import IndeterminateCheckBox from '../../../../../components/common/IndeterminateCheckBox';
import { ACCOUNT_ADMIN_TAB_TITLE } from '../../../../../constants/service/app/accountAdminConstants';
import * as S from './PermissionTable.style';

const PermissionTable = (props) => {
  const { mode = 'create', adminInfo } = props;
  const { handleUpdatePermission, permissionTableData } = usePermissions(mode, adminInfo?.data?.permission);
  const columns = useMemo(() => permissionTableColumns(), []);
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data: permissionTableData,
      autoResetExpanded: false,
      autoResetSelectedRows: false,
    },
    useExpanded,
    useRowSelect,
    useBlockLayout,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: 'selection',
          Header: () => <S.FlexBox>사용 가능 여부</S.FlexBox>,
          Cell: ({ row }) => {
            const initialChecked = row.original.selected;

            const hasIndeterminate = (row) => {
              if (!row.subRows || row.subRows.length === 0) {
                return false;
              }

              const someSelected = row.subRows.some((subRow) => subRow.original.selected);
              const allSelected = row.subRows.every((subRow) => subRow.original.selected);

              if (someSelected && !allSelected) {
                return true;
              }
              // 서브로우 중 하나라도 indeterminate 상태면 이 로우도 indeterminate 상태로 간주
              return row.subRows.some(hasIndeterminate);
            };

            return (
              <S.FlexBox>
                <IndeterminateCheckBox
                  {...row.getToggleRowSelectedProps()}
                  indeterminate={hasIndeterminate(row)}
                  mode={mode}
                  checked={initialChecked}
                  rowKey={row.original.key}
                  onClick={(e) => {
                    handleUpdatePermission(row.original.key, row.original.permissions, e.target.checked);
                  }}
                />
              </S.FlexBox>
            );
          },
        },
        ...columns,
      ]);
    },
  );

  return (
    <S.Container>
      <S.Wrapper>
        <S.Header>
          <strong>{ACCOUNT_ADMIN_TAB_TITLE.ADMIN_PERMISSION}</strong>
        </S.Header>
        <S.Section>
          <table {...getTableProps}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th key={column.id} {...column.getHeaderProps()}>
                      {column.render('Header')}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map((row) => {
                prepareRow(row);
                return (
                  <tr key={row.id} {...row.getRowProps()}>
                    {row.cells.map((cell) => (
                      <S.Td key={cell.id} depth={row.depth} {...cell.getCellProps()}>
                        {cell.render('Cell')}
                      </S.Td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </S.Section>
      </S.Wrapper>
    </S.Container>
  );
};

export default PermissionTable;
